import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { IClientLp } from '../clientLp.interface';
import { clientLpStoreSelector } from '../clientLp.selector';

export const clientLpSelector = createCachedSelector(
  [
    path(clientLpStoreSelector).data(),
    prop<{ lpId: IClientLp['lpId'] }>().lpId(),
  ],
  (lpData, lpId) => {
    return lpData[lpId];
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ lpId: IClientLp['lpId'] }>().lpId(),
});
